import * as t from "io-ts";
import * as util from "../../shared/src/util";

export const codec = t.union([
    t.literal("unknown"),
    t.literal("a"),
    t.literal("b"),
    t.literal("c"),
    t.literal("d"),
    t.literal("e"),
    t.literal("f"),
    t.literal("g"),
    t.literal("h"),
    t.literal("i_wales_only"),
    t.literal("exempt"),
]);

export const values = util.typeValuesFromCodec(codec.types as Array<t.LiteralC<T>>);

type T = t.TypeOf<typeof codec>;

export const toDisplayName = (p: T): string => {
    switch (p) {
        case "unknown":
            return "Unknown";
        case "a":
            return "A";
        case "b":
            return "B";
        case "c":
            return "C";
        case "d":
            return "D";
        case "e":
            return "E";
        case "f":
            return "F";
        case "g":
            return "G";
        case "h":
            return "H";
        case "i_wales_only":
            return "I (Wales only)";
        case "exempt":
            return "Exempt";
        default:
            return util.requireExhaustive(p);
    }
};
